import { UnderwriterSetting } from "./underwriter-settings.model";

export interface Underwriter {
  id: string;
  name: string;
  underwriterSettings: UnderwriterSetting[];
}
